__turbopack_context__.v({
  "active": "Form-module__dUedxG__active",
  "block": "Form-module__dUedxG__block",
  "colors": "Form-module__dUedxG__colors",
  "disabled": "Form-module__dUedxG__disabled",
  "disclaimer": "Form-module__dUedxG__disclaimer",
  "disclaimerTextCaptionStyle": "Form-module__dUedxG__disclaimerTextCaptionStyle",
  "disclaimerTextStyle": "Form-module__dUedxG__disclaimerTextStyle",
  "error-message": "Form-module__dUedxG__error-message",
  "form": "Form-module__dUedxG__form",
  "input-rows": "Form-module__dUedxG__input-rows",
  "light": "Form-module__dUedxG__light",
  "root": "Form-module__dUedxG__root",
  "row": "Form-module__dUedxG__row",
  "select-wrapper": "Form-module__dUedxG__select-wrapper",
  "sizes": "Form-module__dUedxG__sizes",
  "submit": "Form-module__dUedxG__submit",
  "tag": "Form-module__dUedxG__tag",
  "text-description": "Form-module__dUedxG__text-description",
  "titles": "Form-module__dUedxG__titles",
});
